import * as React from 'react';
import {Button} from 'ukas.uux.react-components';
// const PearsonElementsSDK = require('@pearson-components/elements-sdk/build/dist.elements-sdk');
interface ConfirmationModalProps {
    cancelBtnHandler : ( event: React.UIEvent<HTMLSpanElement>) => void;
    successBtnHandler : ( event: React.UIEvent<HTMLSpanElement>) => void;
    conmfirmMsgRender:() => JSX.Element;
}


const ConfirmationModalGeneric = ({ successBtnHandler, cancelBtnHandler, conmfirmMsgRender }: ConfirmationModalProps) =>{
  return ( 
    <div>
      <div >
        {conmfirmMsgRender()}
      </div>
      
      <div className="modal-margin-top"><br /><br />
        <Button
            onClick={cancelBtnHandler.bind(event)}>
            Cancel
        </Button>&nbsp;&nbsp;&nbsp;&nbsp;
        
        <Button variant="primary" 
            onClick={successBtnHandler.bind(event)}>
            Ok
        </Button>
        <br /><br />         
      </div>
    </div>
   
  );
};

export default ConfirmationModalGeneric;
